import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";

export const AdminRoute = () => {
  const { isAdmin, inicializando } = useAuth();
  if (inicializando) return null;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
};
